import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import type { LocationType } from "@/pages/search/types";

import { LocationIcon } from "./icons";

interface LocationTileProps {
  location: LocationType;
}

export default function LocationTile({ location }: LocationTileProps) {
  const areaName = useMemo(() => {
    const strings = [location.locality.locality];

    if (location.distance) {
      strings.push(`${location.distance.toFixed(1)} mi`);
    }

    return strings.join(" | ");
  }, [location]);

  return (
    <div className="flex items-center justify-between pb-4.5 md:px-6 md:pb-0">
      <h2 className="block font-semibold text-15/[1.2em] text-white md:text-18/[1.33em]">
        <Link
          className="hover:underline"
          to={`/location/${location.company.slug}/${location.slug}`}
        >
          {location.displayName || location.company.name}
        </Link>
      </h2>
      {areaName && (
        <div className="flex max-w-1/2 items-center gap-2">
          <LocationIcon className="hidden md:block" />
          <p className="text-right text-12/[1.5em] text-pale-lavender md:text-16/[1.4em] md:text-white/80">
            {areaName}
          </p>
        </div>
      )}
    </div>
  );
}
